export * from './domain';

export function getLoginUrl(): string {
    return '/globaluser/loginpage?from_url=' + encodeURIComponent(window.location.href);
}
